import React from "react";

function MemberNameInput({ onChange, firstNameContent, surnameContent,mfa }) {
  return (
   <>
    {mfa === true ? (
    <>
    <div className="form-group row">
      <div className="col-sm-12">
        <label htmlFor="firstName" data-first-name-label>
          {firstNameContent.label}
        </label>
        <input
          className="form-control"
          type="text"
          name="firstName"
          placeholder={firstNameContent.placeholder}
          onChange={onChange}
        ></input>
      </div>
      </div>
      <div className="form-group row">
      <div className="col-sm-12">
        <label htmlFor="surname" data-sur-name-label>
          {surnameContent.label}
        </label>
        <input
          className="form-control"
          type="text"
          name="surname"
          placeholder={surnameContent.placeholder}
          onChange={onChange}
        ></input>
      </div>
    </div>
    </>
    ):(
<div className="form-group row">
      <div className="col-sm-12">
        <label htmlFor="firstName" data-first-name-label>
          {firstNameContent.label}
        </label>
        <input
          className="form-control"
          type="text"
          name="firstName"
          placeholder={firstNameContent.placeholder}
          onChange={onChange}
        ></input>
      </div>
      <div className="col-sm-12">
        <label htmlFor="surname" data-sur-name-label>
          {surnameContent.label}
        </label>
        <input
          className="form-control"
          type="text"
          name="surname"
          placeholder={surnameContent.placeholder}
          onChange={onChange}
        ></input>
      </div>
    </div>
    )
   }
    </>
  );
}

export default MemberNameInput;
